import styled from 'styled-components'

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  cursor: pointer;
`

interface VerticalLineProps {
  isFirst: boolean
  isLast: boolean
}

export const VerticalLine = styled.div<VerticalLineProps>`
  position: absolute;
  ${props => (props.isFirst ? `bottom: 0;` : `top: 0;`)}
  left: 50%;
  width: 1px;
  height: ${props => (props.isFirst || props.isLast ? '50%' : '100%')};
  transform: translateX(-50%);
  background: ${props => props.theme.colors.color378ff7};
`
